import { REPLUG_AUTH_TOKEN } from '@/constants/Constants';

export const setAuthTokenLocalStorage = (token: string) => {
  localStorage.setItem(REPLUG_AUTH_TOKEN, token);
};

export const getAuthTokenLocalStorage = () => localStorage.getItem(REPLUG_AUTH_TOKEN || '');
